/**
 * Підсумок ПОЗНАЧЕНИХ галочками рядків у списках (ч.1033 — «Розрахунки за
 * документами»; ч.1184 — списки банку). Чисті функції — щоб перевіряти без ag-Grid.
 */

/** Сума грошових значень. У регістрах 4 знаки після коми, тому рахуємо в цілих
 *  десятитисячних: додавання дробів з плаваючою комою дає «хвости»
 *  (0,1 + 0,2 ≠ 0,3), а тут гроші. Порожнє значення — нуль. */
export function sumMoney(values: Array<string | number | null | undefined>): number {
  const units = values.reduce<number>((s, v) => s + Math.round(Number(v ?? 0) * 10000), 0);
  return units / 10000;
}

/** «1 документ / 2 документи / 5 документів» (у т.ч. 11–14 → «документів»). */
export function docsWord(n: number): string {
  const n10 = n % 10;
  const n100 = n % 100;
  if (n10 === 1 && n100 !== 11) return 'документ';
  if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return 'документи';
  return 'документів';
}
